module.exports = __webpack_public_path__ + "media/images/actor_ogp_image/performing-a8c1fab4561d40c946639d8555a8fc9f.png";